import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import numberUtils from 'app/shared/utils/numberUtils';
import format from 'date-fns/format';

// Multibrand-UI Components
import StyledContainer from '@zg-rentals/multibrand-ui/lib/StyledContainer';
import HR from '@zg-rentals/multibrand-ui/lib/HR';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

// styles
import './style.scss';

const propTypes = {
    leadData: PropTypes.object.isRequired,
    listingData: PropTypes.object.isRequired,
};

function LeadRequest({
    isScreenMobile, leadData, listingData, children,
}) {
    const {
        name: leadName,
        dateSaved,
        email,
        message,
        phone,
    } = leadData;

    const { name: listingName } = listingData;
    const isTwilioRecording = message ? message.indexOf('twilio') > -1 : false;

    // tour
    const requestHeader = 'Inquiry';
    const leadDateSaved = `${format(new Date(dateSaved), 'MM/DD/YYYY')}`;

    return (
        <StyledContainer
            className="LeadRequest"
            borderColor="default"
            borderFull={true}
            borderWidth="thin"
        >
            <div className="LeadRequest-Header">
                <Text
                    className="LeadRequest-Title"
                    type="body-tiny"
                >
                    {requestHeader}
                </Text>

                <Text
                    className="LeadRequest-DateSaved"
                    type="body-tiny"
                >
                    {leadDateSaved}
                </Text>
            </div>

            <HR className="LeadRequest-HR" />

            <Text
                className="LeadRequest-ListingName"
                type="body-tiny"
            >
                {listingName}
            </Text>

            <Text
                className="LeadRequest-LeadName"
                type="h1"
            >
                {leadName}
            </Text>

            <div className="LeadRequest-Contact">
                {isScreenMobile ? (
                    <div
                        className={cx([
                            'LeadRequest-Contact-Phone',
                            'LeadRequest-Contact-Phone--mobile',
                        ])}
                    >
                        <Link
                            href={`tel:${phone}`}
                            escape={true}
                        >
                            {numberUtils.formatPhoneNumber(phone)}
                        </Link>
                    </div>
                ) : (
                    <div
                        className={cx([
                            'LeadRequest-Contact-Phone',
                            'LeadRequest-Contact-Phone--desktop',
                            'Link',
                            'Link-primary',
                        ])}
                    >
                        {numberUtils.formatPhoneNumber(phone)}
                    </div>
                )}

                <div className="LeadRequest-Contact-Email">
                    <Link
                        href={`mailto:${email}`}
                        escape={true}
                    >
                        {email}
                    </Link>
                </div>
            </div>

            {isTwilioRecording ? (
                // eslint-disable-next-line jsx-a11y/media-has-caption
                <audio controls={true}>
                    <source src={message} />
                </audio>
            ) : (
                <Text className="LeadRequest-Message" type="body">
                    {message}
                </Text>
            )}

            {children}
        </StyledContainer>
    );
}

LeadRequest.propTypes = propTypes;

export default LeadRequest;
